module.exports = __webpack_public_path__ + "img/undertakingCases21.356f6677.jpg";